import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { guestApi } from '../api';
import { PublicFacility } from '../api_types';
import { GuestReservationWrapper } from './GuestReservationWrapper';
import './styles/GuestFacilityDetails.css';
import LoadingSpinner from '../shared/components/LoadingSpinner';

export const GuestFacilityDetails: React.FC = () => {
  const { businessId, facilityId } = useParams<{ businessId: string; facilityId: string }>();
  const [facility, setFacility] = useState<PublicFacility | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFacility = async () => {
      if (!facilityId || !businessId) {
        setError('No facility ID or business ID provided');
        setLoading(false);
        return;
      }
      
      try {
        const data = await guestApi.getFacilityDetails(businessId, facilityId);
        setFacility(data);
      } catch (err) {
        setError('Failed to load facility details. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchFacility();
  }, [facilityId, businessId]);

  if (!facilityId || !businessId) {
    return (
      <div className="empty-state">
        <h3 className="empty-state-title">Invalid Facility or Business ID</h3>
        <p className="empty-state-text">No facility ID provided.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading-container">
        <LoadingSpinner size="md" />
      </div>
    );
  }

  if (error || !facility) {
    return (
      <div className="empty-state">
        <h3 className="empty-state-title">Error Loading Facility</h3>
        <p className="empty-state-text">{error}</p>
      </div>
    );
  }

  return (
    <div className="guest-facility-details">
      <div className="facility-header mb-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">{facility.name}</h1>
        <p className="facility-address text-sm text-gray-500 mb-1">{facility.address}</p>
        {facility.description && (
          <p className="facility-description text-sm text-gray-400">{facility.description}</p>
        )}
      </div>

      <div className="reservation-calendar">
        <GuestReservationWrapper 
          facilityId={facilityId} 
          businessId={businessId}
          facility={facility}
        />
      </div>
    </div>
  );
}; 